import { render, staticRenderFns } from "./HealthLoader.vue?vue&type=template&id=79bd5da3&scoped=true"
import script from "./HealthLoader.vue?vue&type=script&lang=js"
export * from "./HealthLoader.vue?vue&type=script&lang=js"
import style0 from "./HealthLoader.vue?vue&type=style&index=0&id=79bd5da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd5da3",
  null
  
)

export default component.exports